// src/pages/RoleLanding.tsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import type { Role } from "../types/roles";

/** Devuelve la primera coincidencia según nuestra prioridad */
const pickPrimaryRole = (roles: Role[]): Role => {
  if (roles.includes("profesor")) return "profesor";
  if (roles.includes("cliente")) return "cliente";
  if (roles.includes("admisiones")) return "admisiones";
  if (roles.includes("att_familias")) return "att_familias";
  if (roles.includes("att_profesorado")) return "att_profesorado";
  if (roles.includes("hr")) return "hr";
  if (roles.includes("facturacion")) return "facturacion";
  if (roles.includes("consultor")) return "consultor";

  // cualquier otro → staff
  return roles[0];
};

export default function RoleLanding() {
  const { user } = useAuth();

  if (!user) return <Navigate to="/login" replace />;

  const primary = pickPrimaryRole(user.roles);

  const dest =
    primary === "profesor"
      ? "/profesor/agenda"
      : primary === "cliente"
        ? "/cliente/agenda"
        : primary === "admisiones"
          ? "/agenda" // Para "admisiones" redirigimos a la agenda del staff
          : primary === "att_familias"
            ? "/agenda" // Para "att_familias" redirigimos a la agenda del staff
            : primary === "att_profesorado"
              ? "/agenda" // Para "att_profesorado" redirigimos a la agenda del staff
              : primary === "hr"
                ? "/agenda" // Para "hr" redirigimos a la agenda del staff
                : primary === "consultor"
                  ? "/consultor/agenda" // Para "consultor" redirigimos a la agenda del staff
                  : primary === "facturacion"
                    ? "/agenda" // Para "facturacion" redirigimos a la agenda del staff
                    : "/agenda"; // Para cualquier otro rol, redirigimos a la agenda del staff (admin / HR / etc.)

  return <Navigate to={dest} replace />;
}
